import inventoryAPI from '@/services/api/inventory'

const index = {
	namespaced: true,
	state: () => ({
		assignees: [],
	}),
	getters: {},
	mutations: {
		setAssignees: (state, payload) => {
			state.assignees = [...payload]
		},
	},
	actions: {
		loadAssignees: async ({ commit }, payload) => {
			const { instId } = payload
			const response = await inventoryAPI.lookupInventoryAssignees(instId)
			commit('setAssignees', response.data)
		},
	},
}
export default index
